import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { router } from './router.js';
import { preferredLocale, setLocale } from './i18n/index.js';
import './styles.css';

/* ADR-104: the language this browser reads, before the first render. */
setLocale(preferredLocale());

const container = document.getElementById('root');
if (!container) throw new Error('#root element is missing from index.html');

createRoot(container).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
